"use client";
import * as React from "react";
import { OrDrawerProps, OrDrawer } from "@csc-dashboard/components-library";
import { Drawer } from "@mui/material";

/**
 * ScopedDrawer wraps OrDrawer to ensure MUI portal renders within .csc-admin-panel container
 */
interface ScopedDrawerProps extends OrDrawerProps {
  children: React.ReactNode;
}

export const ScopedDrawer = ({ children, ...props }: ScopedDrawerProps) => {
  const [container, setContainer] = React.useState<HTMLElement | null>(null);

  React.useEffect(() => {
    // Find the .csc-admin-panel container element
    const adminPanel = document.querySelector(
      ".csc-admin-panel",
    ) as HTMLElement;
    if (adminPanel) {
      setContainer(adminPanel);
    }
  }, []);

  return (
    <Drawer
      data-testid={props["data-testid"]}
      open={props.isOpen}
      onClose={props.handleClose}
      anchor="right"
      container={container || undefined}
    >
      <div className="flex flex-col h-screen overflow-y-hidden">{children}</div>
    </Drawer>
  );
};

// Re-export OrDrawer sub-components
ScopedDrawer.Header = OrDrawer.Header;
ScopedDrawer.Content = OrDrawer.Content;
ScopedDrawer.Footer = OrDrawer.Footer;
